<template>
  <div style="padding-bottom: 60px">
    <header>
      <div class="headerDiv" v-on:click="backHistory"  @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">11购物车</p>
      </div>
    </header>
    <div class="shopList">

      <!--<van-checkbox-group   >-->
      <div class="shopListDiv" v-for="(item,index) in carts" :key="index">
        <p ><van-checkbox v-model="item.checked" @click="shopCheak(item)" >{{item.shopTitle}}</van-checkbox></p>

        <!--{{item}}-->
        <div class="shopListDetails" v-for="(a,b) in item.productList">
          <van-checkbox v-model="a.isChecked" @click="ischeak(item,a)"> </van-checkbox>
          <div class="shopListDetailsImg">
            <img src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">
          </div>
          <div class="shopRoduct">
              <p>{{a.productTitle}}</p>
            <p class="shopRoductM"><span>{{a.price*value}}</span><van-stepper v-model="value" /></p>
          </div>
        </div>
      </div>
      <!--</van-checkbox-group>-->
      <!--<van-checkbox-group v-model="result" ref="checkboxGroup">-->
        <!--<div class="shopListDiv">-->
          <!--<p><van-checkbox v-model="checked">店铺名字</van-checkbox></p>-->
          <!--<div class="shopListDetails">-->
            <!--<van-checkbox name="a"> </van-checkbox>-->
            <!--<div class="shopListDetailsImg">-->
              <!--<img src="https://img.yzcdn.cn/vant/apple-1.jpg" alt="">-->
            <!--</div>-->
            <!--<div class="shopRoduct">-->
              <!--<p>产品名称</p>-->
              <!--<p class="shopRoductM"><span>{{money*value1}}￥</span><van-stepper v-model="value1" /></p>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</van-checkbox-group>-->
    </div>
    <!--</footer>-->
    <van-submit-bar :price="3050" :button-text="'结算（'+button+'）'" text-align="center" @submit="toOrder">
      <van-checkbox v-model="isCheckAll" @click="checkAll">全选</van-checkbox>
      <!--<button v-bind:data-index="index" v-on:click="submitClick">提交</button>-->
    </van-submit-bar>
  </div>
</template>

<script>

  export default {
    name: 'message',
    data () {
      return {
        checked: false,
        msg: '',
        color:"#FFFFFF",
//        color:"#000000",
        bool:false,
        radio:'',
        images: [
          'https://img.yzcdn.cn/vant/apple-1.jpg',
          'https://img.yzcdn.cn/vant/apple-2.jpg',
          'https://img.yzcdn.cn/vant/apple-3.jpg',
        ],
        result:[],
        list: ['a', 'b',"c"],
        money:68,
        value1:1,
        value:1,
        button:3,
        all:false,
        data:[
          {id:1,name:"li",timelySwitch:"value1"},
          {id:1,name:"li",timelySwitch:"value2"},
          {id:1,name:"li",timelySwitch:"value3"},
          {id:1,name:"li",timelySwitch:"value4"},
        ],
        timeTipL:[],
        carts:[
          {
            shopTitle:'苹果旗舰店',//商店名
            checked:false,//商店选择的状态
            checkedCount:0,//此商店被选择的商品数量
            productList:[
              {
                isChecked:false,//商品选择状态
                productTitle:'2019款macbook/苹果/MF893/A国航笔记本',//产品名
                category:'15寸/2.3/8G/256/土豪金/标准套餐',
                price:10200,//价格
                count:1//数量
              }
            ]
          },
          {
            shopTitle:'锤子科技旗舰店',
            checked:false,
            checkedCount:0,
            productList:[
              {
                isChecked:false,
                productTitle:'锤子手机手感保护膜',
                category:'登陆月球',
                price:9.9,
                count:1
              },
              {
                isChecked:false,
                productTitle:'锤子手机pro割手版',
                category:'128G/割手版',
                price:1790,
                count:1
              }
            ]
          }
        ],
        isCheckAll:false,//是否全选
        allPrice:0,//所有价格
        allShops:0,//被选中的商店数量
        allCount:0,//被选中的产品数量
      }
    },
    created(){
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toOrder(){
        this.$router.push("/orderPage")
      },
      shopCheak(item){ //商铺全选

//       item.productList.forEach(res=>{
         item.checked ? this.shopTrue(item):this.shopFalse(item)
//       })
      },
      ischeak(item,pro){
        pro.isChecked ? this.checkTrue(item,pro):this.checkFalse(item,pro)
      },
      shopTrue(item){
        item.productList.forEach((res)=>{
//          console.log(res)
          res.isChecked==false ?this.checkTrue(item,res):""
        })
//        item.checked=true
      },
      shopFalse(item){
        item.productList.forEach((res)=>{
          res.isChecked== true ?this.checkFalse(item,res):""
        })
//        item.checked=false
      },
      checkTrue(item,pro){
       console.log(item)
        pro.isChecked=true
        console.log()
        ++item.checkedCount == item.productList.length ? item.checked = true : ""
        item.checked?   ++this.allShops === this.carts.length ? this.isCheckAll = true : this.isCheckAll = false    : ''



      },
      checkFalse(item,pro){
        pro.isChecked=false
        --item.checkedCount
        if(item.checked){

          item.checked = false//当商店状态为选中时改变false
          --this.allShops//商店数减一
        }
        this.isCheckAll = false
      },
      checkAll(){//方法内调用方法
//        this.isCheckAll = !this.isCheckAll
        this.isCheckAll?
          this.carts.forEach((item)=>{this.shopTrue(item)}):
          this.carts.forEach((item)=>{this.shopFalse(item)})
      },


      selectCartser(){//购物车列表
        this.$api.selectCarts({
          "user_id":localStorage.getItem("userid"),
         })
          .then(res=>{
            this.list=res.data
          })
          .catch(res=>{
          })
      },
      submitClick: function(event){

      },
      getList(event){
        console.log(event.path[0])
      },

//      checkAll() {
//        this.bool=!this.bool
//        this.$refs.checkboxGroup.toggleAll(this.bool);
//      },
//      toggleAll() {
//        this.$refs.checkboxGroup.toggleAll(false);
//      },
//      toggle(index) {
//        this.$refs.checkboxes[index].toggle();
//      },
    },
    mounted(){
      console.log(this.submitClick())
      this.selectCartser()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  header{
    width: 100%;
    height: 60px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 70px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .shopList{
    margin-top: 70px;
  }
  .shopListDetailsImg{
    width: 80px;
    height: 80px;
  }
  .shopListDetailsImg img{
    width: 100%;
    height: 100%;
  }
  .shopListDetails{
   display: flex;
    padding: 15px;
  }
.shopRoduct{
  margin-left: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 60%;
}
  .shopListDiv{
    padding: 10px;
  }
  .shopRoductM{
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/shopCart.vue